export default {
      id: "icon--chevron-usage",
      viewBox: "0 0 11 6",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--chevron-usage",
      toString: function () {
        return this.url;
      }
    }